import { AxiosError } from "axios";
import qs from "query-string";
import { useQuery } from "react-query";
import { EarningsCallTranscript } from "../types";
import axiosClient from "../utils/axiosClient";

export const useAllEarningsCallEvent = (
  pageTable: number,
  resultsPerPage: number = 20,
  transcriptId?: string,
) => {
  const newSkip = (pageTable - 1) * resultsPerPage;
  return useQuery<any, AxiosError<any>, EarningsCallTranscript>(
    ["transcript", pageTable],
    async () => {
      const query: Record<string, any> = {
        skip: newSkip,
        limit: resultsPerPage,
        transcriptId,
      };

      const data = await axiosClient.get<EarningsCallTranscript>(
        `/earningsCall/getAll/transcript?${qs.stringify(query)}`
      );

      // console.log("data----", data.data);
      return data;
    },
    {
      staleTime: Infinity,
      keepPreviousData: true,
      enabled: false,
    }
  );
};
